<template>
  <Home>
    <v-container fluid fill-height fill-weight>
      <v-layout row fill-height fill-weight>
        <v-flex xs4>
          <v-data-table
              :headers="headersMain"
              :items="clients"
              hide-actions
              fill-height
              fill-weight
           >
            <template slot="items" slot-scope="props">
              <tr @click="rowClicked(props.item)">
                <td>{{ props.item.clientID }}</td>
                <td>{{ props.item.cloned }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>
        <div style="width:10px"></div>
        <v-flex>
          <v-data-table
              :headers="headersSecond"
              :items="lastLicenses"
              hide-actions
           >
            <template slot="items" slot-scope="props">
              <tr>
                <td>{{ props.item.machineHash }}</td>
                <td>{{ props.item.machineIP }}</td>
                <td>{{ props.item.date }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
  </Home>
</template>

<script>
  import Home from '../Home.vue'
  import dispatcher from '../../dispatcher/dispatcher'

  export default {
    data () {
      return {
        headersMain: [
          { text: 'Cliente', sortable: false, value: 'clientID' },
          { text: 'Clonado', sortable: false, value: 'cloned' }
        ],
        headersSecond: [
          { text: 'Hash', sortable: false, value: 'machineHash' },
          { text: 'IP', sortable: false, value: 'machineIP' },
          { text: 'Data', sortable: false, value: 'date' }
        ],
        clients: [],
        lastLicenses: []
      }
    },
    components: {
      Home
    },
    mounted: function () {
      console.log('this.authenticated', this.$parent.authenticated)
      // if (this.$parent.authenticated) {
      this.loadLicenses()
      // }
    },
    methods: {
      rowClicked: function (itemClicked) {
        console.log('itemClicked', itemClicked)
        dispatcher.getLicensesForClient(itemClicked.clientID)
        .then((result) => {
          console.log('result', result)
          this.lastLicenses = result
        })
        .catch((error) => {
          console.log('error', error)
        })
      },
      loadLicenses: function () {
        // `this` points to the vm instance
        dispatcher.getLicenses()
        .then((result) => {
          this.clients = result
        })
        .catch((error) => {
          console.log('error', error)
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/secure/components/Licenses.vue